// extracted by mini-css-extract-plugin
export default {"Emojis__item":"bgf_a bie_wj bie_ss bie_xl"};